module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921025651_T.59526c97.jpg";